import { BookOpen, Layers, Wrench, Rocket } from "lucide-react";
import { useToolStats } from "@/hooks/useToolStats";

const HomeStats = () => {
  const { totalValueLabel, loading } = useToolStats();
  const stats = [
    { label: "AI Prompts", value: "80+", icon: BookOpen, color: "text-primary", badge: false },
    { label: "Stages", value: "5", icon: Layers, color: "text-secondary", badge: false },
    { label: "Free Credits", value: loading ? "—" : totalValueLabel, icon: Wrench, color: "text-secondary", badge: false },
    { label: "Seed Fund", value: "Coming Soon", icon: Rocket, color: "text-primary", badge: true },
  ];

  return (
    <section className="container mx-auto px-4 sm:px-6 lg:px-8 -mt-4 mb-16">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((stat) => (
          <div
            key={stat.label}
            className="brutal-border brutal-shadow bg-card p-5 flex items-center gap-4 rounded-md"
          >
            <stat.icon className={`w-8 h-8 ${stat.color} shrink-0`} />
            <div>
              {stat.badge ? (
                <span className="inline-block brutal-border bg-primary text-primary-foreground text-[10px] font-black uppercase tracking-[0.1em] px-2 py-1 rounded-sm mb-1">
                  {stat.value}
                </span>
              ) : (
                <div className="text-2xl font-black text-foreground">{stat.value}</div>
              )}
              <div className="text-sm font-medium text-muted-foreground uppercase tracking-[0.08em]">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeStats;
